// convert to and from tags and prompts into their uri form
// we want to make sure uri uses hyphen (-) in place of space ( )

// convert the tag to its uri form
export const tagToUri = tag => {
  const tagMod = tag.replace(/\s/g, '-');
  return `/tag/${tagMod}`;
};

// convert the uri from props.match.params.tagID to its tag form
export const tagFromUri = uri => {
  const tag = uri.replace(/-/g, ' ');
  return tag;
};

// convert id and title of a prompt into uri for the prompt
// note that we modify the prompt title quite a bit
export const promptIdTitleToUri = (promptId, promptTitle) => {
  // 1. remove all reserved characters : / ? # [ ] @ ! $ & ' ( ) * + , ; =
  // 2. remove all unsafe characters " < > % { } | \ ^ `
  // 3. remove all periods (.) and tilde (~)
  // 4. replace all spaces with hyphen
  // 5. truncate the length to 50 characters or less
  // 6. make everything lowercase
  const promptTitleUri = promptTitle
    .replace(/[:/?#[\]@!$&'()*+,;=]+/g, '')
    .replace(/["<>%{}|\\^`]+/g, '')
    .replace(/[.~]/g, '')
    .replace(/\s+/g, '-')
    .substring(0, 50)
    .toLowerCase();
  return `/prompt/${promptId}/${promptTitleUri}`;
};

// pull a prompt's firestore id back out of whatever the admin pasted in
// handles a full url (https://eropenpal.com/prompt/<id>/<title-uri>),
// a bare path (/prompt/<id>/...) or just the id on its own
// used by adminpage/AdminPromptsToolbar.js to jump straight to one prompt
export const promptIdFromInput = input => {
  if (!input) return '';
  const trimmedInput = input.trim();
  const matchedUri = trimmedInput.match(/\/prompt\/([^/?#\s]+)/i);
  if (matchedUri) return matchedUri[1];
  // no /prompt/ segment, so treat the whole thing as the id
  // and strip any leading or trailing slashes the paste may have carried
  return trimmedInput.replace(/^\/+|\/+$/g, '');
};
